import { user_roles } from 'BrdData/Enum';
import UserRoleData from 'BrdData/UserRoleData';
import { DetailPanel, NoContentBox } from 'Components';
import { Switch } from 'Components/HSCInput';
import { useToast } from 'Context';
import { DataManager } from 'Lib/data';
import PropTypes from 'prop-types';
import { Fragment, useEffect, useState } from 'react';

let DM = new DataManager();

const UserRolesPanel = ({ userId, editable = false, ...props }) => {
  const { showSaveSuccessToast } = useToast();
  const [rolesList, setRolesList] = useState([]);

  useEffect(() => {
    if (UserRoleData) {
      DM.add(
        UserRoleData.registerListener('LIST_LOADED', onRolesLoaded),
        UserRoleData,
      );
    }
    if (UserRoleData) {
      DM.add(
        UserRoleData.registerListener('RECORD_CREATED', onRoleSaved),
        UserRoleData,
      );
    }
    if (UserRoleData) {
      DM.add(
        UserRoleData.registerListener('RECORDS_DELETED', onRoleRemoved),
        UserRoleData,
      );
    }
    return () => {
      DM.clear();
    };
  }, []);

  useEffect(() => {
    if (userId) {
      UserRoleData.getRecordList({ where: { '*user_id': userId } });
    }
  }, [userId]);

  const onRolesLoaded = (payload) => {
    if (payload) {
      setRolesList(payload.records.map((role) => role.role));
    }
  };

  const onRoleSaved = () => {
    showRolesSavedToast();
  };

  const onRoleRemoved = () => {
    showRolesSavedToast();
  };

  const showRolesSavedToast = () => {
    showSaveSuccessToast('User Role Saved');
  };

  const onRolesChanged = (role_key, value) => {
    if (value) {
      UserRoleData.createRoleRecord({ user_id: userId, role: role_key });
      setRolesList((prev) => [...prev, role_key]);
    } else {
      UserRoleData.deleteRoleRecord({ user_id: userId, role: role_key });
      setRolesList((prev) =>
        prev.filter((existingRole) => existingRole !== role_key),
      );
    }
  };

  let panelContent = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
        }}>
        {editable ? (
          Object.values(user_roles).map((user_role, i) => {
            return (
              <Fragment key={i}>
                <Switch
                  label={user_role.label}
                  checked={rolesList.includes(user_role.key)}
                  onValueChange={(checked) => {
                    onRolesChanged(user_role.key, checked);
                  }}
                  showCheckedIcon={true}
                  showXIcon={true}
                  disabled={false}
                  readOnly={false}
                />
              </Fragment>
            );
          })
        ) : !rolesList?.length ? (
          <NoContentBox label='No Assigned Roles' />
        ) : (
          Object.values(rolesList).map((user_role_key, i) => {
            return (
              <Fragment key={i}>
                <Switch
                  label={
                    Object.values(user_roles).find(
                      (user_role) => user_role.key === user_role_key,
                    )?.label || user_role_key
                  }
                  checked
                  disabled
                  readOnly
                />
              </Fragment>
            );
          })
        )}
      </div>
    </div>
  );

  return (
    <DetailPanel
      title='Assigned Roles'
      editable={editable}
      collapsible
      {...props}>
      {panelContent}
    </DetailPanel>
  );
};

UserRolesPanel.propTypes = {
  userId: PropTypes.number,
  editable: PropTypes.bool,
};

export default UserRolesPanel;
